import {
  isProductConfigurable 
} from "@/util/isProductConfigurable"
import {
  useMemo, useState 
} from "react"

const INITIAL_OPTION_CODES = new Map()

const deriveOptionCodesFromProduct = (product: any) => {
  // If this is a simple product it has no option codes.
  if (!isProductConfigurable(product)) {
    return INITIAL_OPTION_CODES
  }

  // Initialize optionCodes based on the options of the product.
  const initialOptionCodes = new Map()

  for (const {
    attribute_id,
    attribute_code,
  } of product.configurable_options) {
    initialOptionCodes.set(attribute_id, attribute_code)
  }

  return initialOptionCodes
}

export const useGetOptionCode = ({
  product 
}: { product: any }) => {
  const derivedOptionCodes = useMemo(
    () => deriveOptionCodesFromProduct(product),
    [product]
  )

  const [optionCodes] = useState(derivedOptionCodes)

  return {
    optionCodes 
  }
}
